var _circle, _circle2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddressConfirmationStatus2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 37,
    viewBox: "0 0 108 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4177,
    cy: 18.3379,
    r: 17.8542,
    fill: "#FD9435"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.9436,
    cy: 18.3379,
    r: 17.8542,
    fill: "#FD9435"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0891 18.6238C70.6414 18.6238 71.0891 18.1761 71.0891 17.6238C71.0891 17.0715 70.6414 16.6238 70.0891 16.6238V18.6238ZM34.272 18.6238H70.0891V16.6238H34.272V18.6238Z",
    fill: "#FD9435"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9744 12.5403V10.8803H19.7344V25.3403H17.8944V12.5403H15.9744Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2117 23.8803C86.905 22.5203 88.2317 21.407 89.1917 20.5403C90.1517 19.6603 90.9584 18.747 91.6117 17.8003C92.2784 16.8403 92.6117 15.9003 92.6117 14.9803C92.6117 14.1137 92.3984 13.4337 91.9717 12.9403C91.5584 12.4337 90.885 12.1803 89.9517 12.1803C89.045 12.1803 88.3384 12.467 87.8317 13.0403C87.3384 13.6003 87.0717 14.3537 87.0317 15.3003H85.2717C85.325 13.807 85.7784 12.6537 86.6317 11.8403C87.485 11.027 88.585 10.6203 89.9317 10.6203C91.305 10.6203 92.3917 11.0003 93.1917 11.7603C94.005 12.5203 94.4117 13.567 94.4117 14.9003C94.4117 16.007 94.0784 17.087 93.4117 18.1403C92.7584 19.1803 92.0117 20.1003 91.1717 20.9003C90.3317 21.687 89.2584 22.607 87.9517 23.6603H94.8317V25.1803H85.2117V23.8803Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddressConfirmationStatus2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/addressConfirmationStatus2.1d792dc5.svg";
export { ForwardRef as ReactComponent };